import React from "react";
import { useTranslation } from "react-i18next";
import { ExclamationCircle } from "./icons";

interface PaymentErrorProps {
  errorMessages?: string[];
}

const PaymentError: React.FC<PaymentErrorProps> = ({ errorMessages }) => {
  const { t } = useTranslation();
  const messages =
    !errorMessages || errorMessages.length === 0
      ? [t("payment_error_generic", "Something went wrong with your payment. Please try again.")]
      : errorMessages;

  return (
    <div
      role="alert"
      className="gcw:flex gcw:items-start gcw:flex-col gcw:w-full gcw:mt-bs-3 gcw:rounded-md gcw:border gcw:border-error gcw:bg-error/10 gcw:p-bs-3 gcw:text-error widget-error-panel"
      data-testid="payment-error-alert"
    >
      {messages.map((errorMessage) => (
        <div key={errorMessage} className="gcw:flex gcw:items-center">
          <span className="widget-panel-icon">
            <ExclamationCircle data-testid="exclamation-circle-icon" color="#9a1212ff" size={16} className="gcw:me-4" />
          </span>
          <span>{errorMessage}</span>
        </div>
      ))}
    </div>
  );
};

export default PaymentError;
